import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';

import loadingGif from '../../assets/images/loading.gif';

import {
  fetchAccountBankLinks,
  cancelBankLink,
} from '../../actions/bankLinks';

import {
  addNotification,
} from '../../actions/notifications';

import './styles.css';
import { LAYOUT } from '../Layout/enums';
import BankInfo from '../SignUp/BankInfo';
import { filterActiveBankLinks } from '../../helpers/filterActiveBankLink';

export class UnconnectedBankLinks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      promptDeleteId: null,
    };
  }

  componentDidMount() {
    this.props.fetchAccountBankLinks(this.props.accountNumber);
  }

  getLinkItem = (link) => {
    const { promptDeleteId } = this.state;
    const bankName = get(link, 'bankName', '');
    const canDelete = get(link, 'canDelete', false);
    const verifyStatus = get(link, 'verifyStatus', false);
    const bankLinkOid = get(link, 'bankLinkOid', '');
    const bankAccountNumber = get(link, 'bankAccountNumber', '');
    let input = (<input
      type="button"
      styleName="link"
      value="Requires verification"
      onClick={() => {}} // TODO: verify link (if necessary)
    />);
    if (verifyStatus) {
      if (canDelete) {
        input = bankLinkOid === promptDeleteId ?
          (
            <div styleName="deleteCol">
              <div styleName="formError">Please&nbsp;
                <a href="mailto:clientservices@myipo.com">
                  contact a My IPO representative
                </a>
                &nbsp;to delete your bank link.
              </div>
            </div>
          ) : (<input
            id={`btnDel${bankLinkOid}`}
            type="button"
            styleName="link"
            value="Delete"
            onClick={() => this.setState({ promptDeleteId: bankLinkOid })}
          />);
      } else {
        input = <div styleName="labelGrey">Transactions Pending</div>;
      }
    }
    return (
      <div key={bankLinkOid} styleName="bankLinkRow">
        <div styleName="labelGrey">{`${bankName} ${bankAccountNumber}`}</div>
        {input}
      </div>
    );
  };

  deleteLink = async (accountNumber, bankLinkId) => {
    await this.props.cancelBankLink(accountNumber, bankLinkId);
    this.props.fetchAccountBankLinks(accountNumber);
  };

  render() {
    const {
      layout,
      accountBankLinks,
      accountBankLinksIsFetching,
      accountNumber,
    } = this.props;
    let styleSuff = '';
    switch (layout) {
      case LAYOUT.TAB:
        styleSuff = 'Tab';
        break;
      case LAYOUT.MOB:
        styleSuff = 'Mob';
        break;
      // no default
    }
    const bankLinksResult = filterActiveBankLinks(accountBankLinks);
    const bankLinks = bankLinksResult.bankLinks.sort((a, b) => {
      if (a.verifyStatus > b.verifyStatus) {
        return -1;
      } else if (b.verifyStatus > a.verifyStatus) {
        return 1;
      }
      if (a.bankName > b.bankName) {
        return -1;
      } else if (b.bankName > a.bankName) {
        return 1;
      }
      return 0;
    });
    const list = bankLinks.map(link =>
      this.getLinkItem(link, accountNumber));
    const bankLink = (<BankInfo accountNumber={accountNumber} isSignUp={false} onNext={() => {}} />);
    const bankLinkMessage = (
      <div>
        <span>
          For security purposes we are temporarily restricting bank link management. Please&nbsp;
        </span>
        <a href="mailto:clientservices@myipo.com" styleName="contactLink">
          contact a MyIPO representative
        </a>
        <span>
          &nbsp;to add a new bank link to your account.
        </span>
      </div>
    );
    const bankLinkList = bankLinks.length ? (list) : (
      <div styleName="noLinksComment">
        {!bankLinksResult.hasDeletedBankLinks ? bankLink : bankLinkMessage}
      </div>
    );

    return (
      <div styleName={`formGroup${styleSuff}`}>
        <div styleName="flexRow">
          <div styleName={`labelBlack${styleSuff}`}>Bank Links</div>
        </div>
        {accountBankLinksIsFetching ? (
          <img styleName="bankLinkLoading" src={loadingGif} alt="Loading..." />
        ) : (bankLinkList)}
      </div>
    );
  }
}

UnconnectedBankLinks.propTypes = {
  layout: PropTypes.number,
  accountNumber: PropTypes.string,
};

UnconnectedBankLinks.defaultProps = {
  accountNumber: 'unknown',
  layout: LAYOUT.DESK,
};


const mapStateToProps = (state, props) => ({
  accountBankLinks: get(state, `accountBankLinks.[${props.accountNumber}].data`, []),
  accountBankLinksIsFetching: get(state, `accountBankLinks.[${props.accountNumber}].isFetching`, false),
});

const mapDispatchToProps = {
  fetchAccountBankLinks,
  addNotification,
  cancelBankLink,
};


export default connect(mapStateToProps, mapDispatchToProps)(UnconnectedBankLinks);



// WEBPACK FOOTER //
// ./src/components/ManageAccount/BankLinks.js